import React, { useState, useEffect } from 'react';
import * as youkuApi from 'Components/utils/youku-api';
import Image from './Image';

export function YoukuThumbnail(props) {
  const [thumbnailUrl, setThumbnailUrl] = useState(null);

  useEffect(() => {
    const youkuRegEx = new RegExp('https://vthumb.ykimg.com/([a-zA-Z0-9]+)');
    const urlMatch = youkuRegEx.exec(props.imageUrl);
    if (urlMatch && urlMatch[1]) {
      youkuApi
        .getVideoThumbnailUrl(urlMatch[1])
        .then((youkuThumbnail) => {
          setThumbnailUrl(youkuThumbnail);
        })
        .catch(() => null);
    }
  }, []);

  return <Image {...props} imageUrl={thumbnailUrl} />;
}
